import React, { Component } from 'react';
import './Button.css';

export default class Button extends Component {
  render() {
    return (
    	<button
    		className={'button ' + (this.props.buttonColor) + " " + (this.props.buttonState) + " " + (this.props.size)}
    		onClick={this.props.clickAction}
            disabled={this.props.disabled}
            >
            {this.props.imagePath ?
                <img src={this.props.imagePath} alt={this.props.altText}/>
            : null}
    		{
    			this.props.text
    		}
    	</button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Button/Button.js